export default __webpack_public_path__ + "static/media/IMG_3896 - Copy - Copy.514277d5.jpg";